// extracted by mini-css-extract-plugin
export default {"modal":"modal-aR70k","container":"container-BMPZW","title":"title-LIn_r","subTitle":"subTitle-ARNUF","body":"body-MeT3v"};